import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { sha256 } from 'js-sha256';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../_models';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	private currentUserSubject ?: BehaviorSubject<User> | null;
	public currentUser ?: Observable<User> | null;

	constructor(private http : HttpClient) {
		this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser') || 'null'));
		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue() : User {
		return this.currentUserSubject!.value;
	}
	public get isAuthenticated() : Boolean {
		if (this.currentUserSubject!.value && this.currentUserSubject!.value.username != '') {
			console.log('Authenticated');
			return true;
		}
		console.log('Un-authenticated');
		return false;
	}


	login(username : string, password : string, onCompleted : (userinfo : any) => void) {
		const vhashPassword = sha256(password + 'BILETLINGO@2018##');
		console.log('Login');
		const headerHttp = new HttpHeaders();
		headerHttp.set('Content-Type', 'application/x-www-form-urlencoded');
		const vbody = {
			email: username,
			password: vhashPassword
		};

		let res = {
			userid: '1',
			email: 'chuphucben@gmail.com',
			username: 'chuphucben',
			deviceId: '1',
			googleUserId: '1',
			password: '1',
			fullName: 'Chu Phúc Bền',
			birthday: '',
			phoneNumber: '0948003456',
			address: '712, Quang Trung, Ha Dong, Ha Noi',
			zipcode: '',
			city: 'Ha noi',
			country: 'Viet nam',
			contract: [],
			isDeleted: '',
			dbversion: '',
			currentdate: '',
			sessionID: '1',
		};
		localStorage.setItem('currentUser', JSON.stringify(res));
		this.currentUserSubject?.next(res);
		onCompleted(res);

		// return this.http.post<any>('http://biletenglish.com:9099/rapi/login', vbody, {
		// 	headers: headerHttp,
		// 	observe: 'body',
		// 	responseType: 'json'
		// })
		// 	.subscribe(
		// 		res => {
		// 			// login successful if there's a jwt token in the response
		// 			if (res) {
		// 				//console.log(JSON.stringify(res));
		// 				// store user details and jwt token in local storage to keep user logged in between page refreshes
		// 				localStorage.setItem('currentUser', JSON.stringify(res));

		// 				this.currentUserSubject?.next(res);
		// 			}
		// 			onCompleted(res);
		// 		},
		// 		err => {
		// 			console.log(err);
		// 			onCompleted(null);
		// 		});
	}
	logout(onCompleted : () => void) {
		// remove user from local storage to log user out
		localStorage.removeItem('currentUser');
		this.currentUserSubject?.next(new User());
		onCompleted();
	}
}